<script setup lang="ts">
const { t } = useI18n({
  useScope: 'local',
});
const emit = defineEmits<{
  (event: 'badge-clicked'): void;
}>();

const props = defineProps<{
  name: string;
}>();

</script>

<template>
  <div class="message-box">
    <tw-ui-message-box type="ring">
      <tw-icon-rt-trade-variant variant="ring" class="icon" />
      <h2>{{ t('headline', [props.name]) }}</h2>
      <div class="message-box-footer" ref="messageBoxFooterRef">
        <tw-ui-action @click="emit('badge-clicked')" is="link" variant="button-ring">
          {{ t('swap-details') }}
        </tw-ui-action>

      </div>
    </tw-ui-message-box>
  </div>
</template>

<style scoped lang="scss">
@import '~/assets/styles/tw-variables.scss';
@import '~/assets/styles/tw-mixins.scss';

.message-box {

  h2 {
    font-size: 1.125rem;
    font-weight: 800;
    line-height: 24px;
  }
  h2,
  p {
    margin: 0;
    text-align: center;
  }

  .ring {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
  }

  .icon {
    width: 3rem;
    height: 3rem;
    fill: $trade-variant-ring;
  }

  &-footer {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    .action--button-ring {
      width: 100%;
    }
    @include tw-is-desktop {
      .action--button-ring {
        width: auto;
      }
    }
  }
}
</style>

<i18n lang="json">
{
  "de": {
    "headline": "{0} ist ein möglicher Tauschpartner 3 im Ringtausch.",
    "swap-details": "Tauschdetails"
  },
  "en": {
    "headline": "{0} is a potential partner 3 in the ring swap.",
    "swap-details": "Swap details"

  }
}
</i18n>
